<template>
    <div>
        <google-map id="map" ref="map" class="hidden md:block h-96 mb-10" v-bind="mapProperties" v-if="campings.length > 0">
            <google-map-marker
                v-for="(camping, index) in filteredCampings"
                :key="camping.id"
                :title="camping.title"
                :position="sanitizeLocation(camping.location)"
                :animation="2"
                @click="panToMarker(sanitizeLocation(camping.location))"
            />
        </google-map>
        <div class="mb-12 flex flex-wrap">
            <div class="w-full lg:w-1/4">
                <button
                    class="text-white flex space-x-2 w-full md:max-w-max-content py-3 px-5 bg-green-500 items-center font-medium rounded-lg justify-center text-sm md:text-base lg:hidden mb-5">
                    <span>Camping filters</span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                         class="w-5 h-5 text-white">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                    </svg>
                </button>
                <button
                    v-for="facet in facets"
                    class="space-x-3 flex items-center mb-3 px-2 py-1 hidden lg:flex"
                    @click="toggleFacet(facet)"
                >
                    <div
                        class="w-5 h-5 rounded-full border items-center justify-center flex"
                        :class="{'border-green-500 bg-green-500':facet.isActive, 'border-gray-500':!facet.isActive}"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            class="w-4 h-4 text-white duration-200 transition-all opacity-0"
                            :class="{'opacity-100':facet.isActive}"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd"
                            />
                        </svg>
                    </div>
                    <div>
                        {{ facet.name }} <span class="text-xs text-gray-600">({{ facet.amount }})</span>
                    </div>
                </button>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-1 gap-5 md:gap-3 w-full lg:w-3/4">
                <a :href="camping.url" :title="camping.title" v-for="camping in filteredCampings"
                   class="bg-gray-400 hover:shadow-lg shadow-md flex flex-wrap overflow-hidden rounded-md xl:mb-8 group  duration-200 transition-all">
                    <div class="w-full xl:w-1/3 relative h-40 xl:h-full bg-center bg-no-repeat bg-cover"
                         v-bind:style="{ backgroundImage: 'url(' + camping.image + ')' }">
                    </div>
                    <div class="py-4 px-8 w-full xl:w-2/3">
                        <h2 class="text-lg md:text-xl font-serif font-bold  mb-3">{{ camping.title }}
                        </h2>
                        <span class="hidden xl:block">{{ camping.region }}</span>
                        <p class="hidden xl:block prose-sm md:prose mb-3">
                            {{ camping.introduction }}
                        </p>
                        <div class="flex flex-wrap w-full">
                            <div class="w-full xl:w-3/5 mb-5 xl:mb-0">
                                <ul class="grid grid-cols-1 gap-1 text-lg">
                                    <li v-for="usp in camping.usps"
                                        class="flex  space-x-3 leading-normal text-sm lg:text-base">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                            class="w-4 h-4 text-green-500 flex-shrink-0 relative mt-1"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clip-rule="evenodd"
                                            />
                                        </svg>

                                        <span
                                            :class="{'bg-green-400': activeRegionFacets.find(activeFacet => activeFacet.name === usp )}">
                                            {{ usp }}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div class="w-full xl:w-2/5 flex justify-start xl:justify-end items-end">
                                <span
                                    class="text-white flex space-x-2 w-full md:max-w-max-content py-3 px-5 bg-orange-500 items-center font-medium rounded-lg justify-center hover:bg-orange-600 text-sm group-hover:bg-green-500 duration-200 transition-all">
                                    <span>{{ showTitle }}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         stroke="currentColor" class="w-5 h-5 text-white">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                              d="M9 5l7 7-7 7"/>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "CampingOverview",
    props: ['locale', 'showTitle', 'region'],
    data: function () {
        return {
            mapProperties: {
                center: {
                    lat: 46.543239942454186,
                    lng: 2.1784194855100196
                },
                zoom: 6,
                mapTypeId: "hybrid",
                options: {
                    disableDefaultUI: true,
                    zoomControl: true,
                    scaleControl: false,
                }


            },
            campings: [],
            facets: [],
            searchTerm: '',
        };
    },
    created() {
        this.getCampingOveriew();
    },
    methods: {
        panToMarker(pos) {
            this.$refs.map.panTo(pos);
            console.log(this.$refs.map);
        },
        sanitizeLocation(location) {
            return {
                lat: parseFloat(location.lat),
                lng: parseFloat(location.lng)
            }
        },
        toggleFacet(facet) {
            facet.isActive = !facet.isActive;
        },
        getCampingOveriew() {
            axios.get(`/api/campings/${this.locale}`).then((response) => {
                this.campings = response.data.campings;
                this.facets = response.data.regions;

                if (!this.region) {
                    return;
                }

                let facet = this.facets.find((filterRegion) => filterRegion.slug === this.region);
                if (!facet) {
                    return;
                }

                facet.isActive = true;

            });
        },
    },
    computed: {
        filteredCampings() {
            if (this.activeRegionFacets.length === 0) {
                return this.campings;
            }

            return this.campings.filter(camping => this.activeRegionFacets.includes(camping.region));
        },

        activeRegionFacets() {
            return this.facets.filter(facet => facet.isActive).map(facet => facet.name);
        }
    }
};
</script>

<style scoped>

</style>
